/**
 * Request A Call Component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showPopUp } from '../actions/action-rac';
import RACMainPopUp from './RACMainPopUp';
import l10n from '../../lib/reactPPl10nHelper';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import { RAC } from '../constants/PropTypesShapes';
import contentHelper from '../../lib/contentHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
// import { getPlural } from '../../lib/date-helper';

const label = {
  preferCallback: l10n.getContent('smarthelp/callUs.call.rac.preferCallback'),
  callYouBack: l10n.getContent('smarthelp/callUs.call.rac.callYouBack'),
  callYouBck: i18n.message('smarthelp/callUs.call.rac.callYouBck'),
  alreadyError: l10n.getContent('smarthelp/callUs.call.rac.alreadyError'),
  oooError: l10n.getContent('smarthelp/callUs.call.rac.oooError'),
  invalidPhoneError: l10n.getContent('smarthelp/callUs.call.rac.invalidPhoneError'),
  problemError: l10n.getContent('smarthelp/callUs.call.rac.problemError'),
  apologizeError: l10n.getContent('smarthelp/callUs.call.rac.apologizeError'),
  choiceAlertMin_zero: i18n.message('smarthelp/callUs.call.rac.choiceAlertMin_zero'),
  choiceAlertMin_one: i18n.message('smarthelp/callUs.call.rac.choiceAlertMin_one'),
  choiceAlertMin_two: i18n.message('smarthelp/callUs.call.rac.choiceAlertMin_two'),
  choiceAlertMin_few: i18n.message('smarthelp/callUs.call.rac.choiceAlertMin_few'),
  choiceAlertMin_many: i18n.message('smarthelp/callUs.call.rac.choiceAlertMin_many'),
  choiceAlertMin_other: i18n.message('smarthelp/callUs.call.rac.choiceAlertMin_other'),
};
const isLoggedIn = Page.isLoggedIn();

class RequestACall extends Component {
  // Check RAC Eligibility
  isRacEligible() {
    return this.props.rac && this.props.rac.racInfo && this.props.rac.racInfo.request_a_call_enabled;
  }

  isRacContainsPrimary() {
    return !!this.props.rac && !!this.props.rac.racInfo && !!((this.props.rac.racInfo.phone_details[0] || {}).phone || {}).national_number;
  }

  nonServiceError() {
    return !!(this.props.rac && this.props.rac.error);
  }

  isEWTResponse() {
    return !!(this.props.rac && (this.props.rac.ewt >= 0));
  }

  errorMessageForRACError() {
    const errMap = {
      107009: label.alreadyError,
      107010: label.oooError,
      108005: label.invalidPhoneError,
      apologizeError: label.apologizeError,
    };
    const failRacFpti = {
      107009: 'racFailAlreadyPlaced',
      107010: 'racFailNonHours',
      108005: 'racFailInvalidNumber',
      apologizeError: 'racFailureAlert',
    };
    const fptiErr = (failRacFpti[this.props.rac.messageCode]) ? failRacFpti[this.props.rac.messageCode] : 'racFailureAlert';
    trackPage({ id: 'requestACallError', link: `error|${fptiErr}` });

    return (errMap[this.props.rac.messageCode]) ? errMap[this.props.rac.messageCode] : label.problemError;
  }

  renderSuccessModule() {
    if (this.props.rac.enabled && this.props.rac.racSubmit && this.props.rac.racSuccess) {
      const sucMsg = contentHelper(label.callYouBck, { num: this.props.rac.racFormattedNumber });
      // RAC success show case
      trackPage({ id: 'requestACallSuccess', link: 'racSuccessAlert' });
      return (
        <div className="racSuccess">
          <div className="rac-success-alert" id="racSuccessId" tabIndex="0">
            <div className="vx_icon vx_icon-small vx_icon-circled-checkmark-small rac-success-icon" />
            <span className="rac-success-message">{Page.getHTMLElement({ message: sucMsg, useHTML: true })}</span>
          </div>
        </div>
      );
    }
    return null;
  }

  renderMainPopUp() {
    if (this.props.rac.status) {
      return <RACMainPopUp />;
    }
    return null;
  }

  renderAlert() {
    if (this.props.rac.enabled && !this.props.rac.racSubmit && !this.props.rac.alertFpti) {
      trackPage({ id: 'requestACall', link: 'racChoiceAlert' });
    }
    if (this.props.rac.enabled && !this.props.rac.racSubmit) {
      // const griffinPluralLabel = `choiceAlertMin_${getPlural(this.props.rac.ewt)}`; // Griffin Plural has CSP violations
      const griffinPluralLabel = this.props.rac.ewt === 1 ? 'choiceAlertMin_one' : 'choiceAlertMin_other';
      return (
        <div className="racAlert">
          <div className="rac-choice-alert">
            <span>{contentHelper(label[griffinPluralLabel], { ewt: this.props.rac.ewt })}</span>
&nbsp;
            <button
              className="alertStyle"
              id="rac-choice"
              aria-haspopup="true"
              onClick={() => {
                trackLink({ id: 'requestACall', link: 'racPopUpAlert' });
                this.props.showPopUp();
              }}
            >
              {label.preferCallback}
            </button>
          </div>
        </div>
      );
    }
    return null;
  }

  renderErrorModule() {
    if (this.props.rac.enabled && this.props.rac.racSubmit && !this.props.rac.racSuccess) {
      return (
        <div className="racFailure">
          <div className="rac-failure-alert" id="racFailureId" tabIndex="0">
            <div className="vx_icon vx_icon-small vx_icon-critical-small rac-failure-icon" />
            <span
              className="rac-failure-message"
            >
              {' '}
              {this.errorMessageForRACError()}
            </span>
          </div>
        </div>
      );
    }
    return null;
  }

  renderRAC() {
    return (
      <div>
        {this.renderAlert()}
        {this.renderMainPopUp()}
        {this.renderSuccessModule()}
        {this.renderErrorModule()}
      </div>
    );
  }

  render() {
    // it should be 1) loggedin 2) rac eligibimity non service error 3) it has EWT 4) rac is enabled(eligibility) 5)it has primary number
    return (isLoggedIn && !this.nonServiceError() && this.isEWTResponse() && this.isRacEligible() && this.isRacContainsPrimary()) ? this.renderRAC() : null;
  }
}

RequestACall.propTypes = {
  rac: PropTypes.shape(RAC).isRequired,
  showPopUp: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    rac: state.rac,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showPopUp }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestACall);
